import { NamedProperty } from "sprint-common-web";

export const sortVersionTypesByName = (listToSort: NamedProperty[]): NamedProperty[] => {
    return listToSort.sort((prev, next) => (prev.name !== next.name ? (prev.name < next.name ? -1 : 1) : 0));
};
